import fiscalInstance from '../../instance'

const printReport = (reportId) => {
	return fiscalInstance.post('/cashRegisterClose/reports/' + reportId + '/print')
}

export default printReport
